




























import {
    Component,
    Watch,
    Vue
} from 'vue-property-decorator';

import {
    WebSiteModule
} from '@/store';
import Menu from '@/models/Menu';

@Component({
    components: {

    },
})
export default class Article extends Vue {
    // Состояние BVI для шаблона
    private isBVIToggled = false;
    // Наблюдатель за изменением класса body (fallback)
    private bodyClassObserver: MutationObserver | null = null;

    private menuItems = new Array < Menu > ();
    private get menuItemsExist() {
        return this.menuItems.length > 0;
    }
    private get allMenuItems() {
        return WebSiteModule.state.MenuItems;
    }

    public mounted(): void {
        // BVI: первичная синхронизация и подписки
        this.syncBviState();

        // 1) Кастомное событие из App.vue (если добавлено)
        window.addEventListener('bvi:toggle', this.onBviToggle as EventListener);

        // 2) Обновление по localStorage (если включают в другой вкладке)
        window.addEventListener('storage', this.onStorage);

        // 3) Fallback: наблюдаем класс body (актуально для CSS-режима)
        this.bodyClassObserver = new MutationObserver(() => this.syncBviState());
        this.bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        this.$nextTick(async () => {
            // Сохраняем навигацию
            await WebSiteModule.actions.navigate(this.$route.fullPath);

            // Если меню уже загружено, то строим его
            if (WebSiteModule.state.MenuItems && WebSiteModule.state.MenuItems.length > 0) {
                this.buildMenuItems();
            }
        });
    }
    public beforeDestroy(): void {
        window.removeEventListener('bvi:toggle', this.onBviToggle as EventListener);
        window.removeEventListener('storage', this.onStorage);
        if (this.bodyClassObserver) {
            this.bodyClassObserver.disconnect();
            this.bodyClassObserver = null;
        }
    }
    private buildMenuItems() {
        const id = Number(this.$route.meta.id);
        this.menuItems = new Array < Menu > ();
        for (let i = 0; i < WebSiteModule.state.PlainMenuItems.length; i++) {
            const mi = WebSiteModule.state.PlainMenuItems[i];
            if (mi.ParentId === id) {
                this.menuItems.push(mi);
            }
        }
    }
    private itemClick(item: Menu) {
        if (item.FullPath) {
            if (this.$route.fullPath !== item.FullPath) {
                this.$router.push(item.FullPath);
            }
        }
    }
    @Watch('menuItems')
    public menuItemsChanges(): void {
        if (!this.allMenuItems || this.allMenuItems.length === 0) {
            return;
        }
    }
    // ---- BVI helpers ----
    private detectBviState(): boolean {
        // 1) Наш ключ в localStorage
        const ls = localStorage.getItem('bvi_enabled') === '1';
        // 2) Fallback-класс CSS-режима
        const bodyHasClass = document.body.classList.contains('bvi-body');
        // 3) Популярные селекторы панели BVI (на случай, если библиотека активна)
        const hasPanel = !!document.querySelector('.bvi-panel, .bvi__panel, #bvi-panel');
        return ls || bodyHasClass || hasPanel;
    }

    private syncBviState() {
        this.isBVIToggled = this.detectBviState();
    }

    private onBviToggle = (e: Event) => {
        // Ожидаем detail.enabled от App.vue
        const ce = e as CustomEvent;
        if (ce && ce.detail && typeof ce.detail.enabled === 'boolean') {
            this.isBVIToggled = ce.detail.enabled;
        } else {
            this.syncBviState();
        }
    };

    private onStorage = (e: StorageEvent) => {
        if (e.key === 'bvi_enabled') {
            this.syncBviState();
        }
    };
}
